import { render, staticRenderFns } from "./CoinsAgreePopup.vue?vue&type=template&id=24c42c35&scoped=true&"
import script from "./CoinsAgreePopup.vue?vue&type=script&lang=js&"
export * from "./CoinsAgreePopup.vue?vue&type=script&lang=js&"
import style0 from "./CoinsAgreePopup.vue?vue&type=style&index=0&id=24c42c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c42c35",
  null
  
)

export default component.exports